import Link from 'next/link';
import { Badge, Box, Button, Flex, Heading } from '@chakra-ui/react';
import {
  format,
  formatDistanceToNow,
  fromUnixTime,
  isFuture,
  isPast,
} from 'date-fns';
import { useTranslation } from 'next-i18next';

import useDateFnsLocale from '../../lib/hooks/useDateFnsLocale';
import { EventTypeFromKaik } from '../../lib/types';

type Props = EventTypeFromKaik;

function EventCard(props: Props) {
  const { t } = useTranslation(['common', 'event']);
  const dateFnsLocale = useDateFnsLocale();

  const { id, name, startedAt, endedAt } = props;

  const startedAtDate = fromUnixTime(startedAt);
  const endedAtDate = fromUnixTime(endedAt);
  const isEventOngoing = isPast(startedAtDate) && isFuture(endedAtDate);

  return (
    <Flex
      borderRadius="lg"
      shadow="md"
      p={4}
      bg="white"
      mb={4}
      alignItems="center"
      justifyContent="space-between"
      flexDirection={{ base: 'column', md: 'row' }}
    >
      <Box mr={{ base: '0', md: '2' }}>
        <Flex>
          {isEventOngoing && (
            <Flex flexShrink={0}>
              <Box mt="-4px">
                <Badge colorScheme={'red'} height="auto">
                  {t('event:Ongoing')}
                </Badge>
                <div className="on-air-icon"></div>
              </Box>
            </Flex>
          )}
          <Heading as="h2" fontSize="lg" color="gray.700" mb={2}>
            {name}
          </Heading>
        </Flex>
        <Heading as="h4" fontSize="sm" color="gray.500">
          {isEventOngoing
            ? t('event:Ongoing Time Hint', {
                startedAt: format(startedAtDate, 'p'),
                distanceToNow: formatDistanceToNow(startedAtDate, {
                  locale: dateFnsLocale,
                }),
              })
            : format(startedAtDate, 'p')}
        </Heading>
      </Box>
      <Link href={`/events/${id}`} passHref>
        <Button
          as="a"
          variant="outline"
          ml="auto"
          colorScheme="red"
          mt={{ base: '2', md: 0 }}
          w={{ base: '100%', md: 'fit-content' }}
          flexShrink={0}
        >
          {t('common:View Event')}
        </Button>
      </Link>
    </Flex>
  );
}

export default EventCard;
